module.exports = __webpack_public_path__ + "static/media/flash-1.0e303f4a.mp3";